import { generateAPI } from "../api.generator";
import { BASE_API_REQ } from "../../utils/base.api.legacy";

export type Session = {
  accountType: "user" | "admin";
  userWeddingRole: string;
};

export const getSession = generateAPI<Partial<BASE_API_REQ>, Session>(
  "get",
  "auth/session",
);
